import globals from '../globals';
import Session from './Session';

const {
  google: {
    analytics: { id: analyticsId, appName },
    ads: { id: adsId }
  }
} = globals;

class GoogleAnalytics {
  constructor() {
    this.runningOniOS = Session.get('runningOniOS');
    this.runningInUnity = Session.get('runningInUnity');
    // Google Analytics won't work inside webview on iOS
    // if (this.runningOniOS && this.runningInUnity) return;
    window.dataLayer = window.dataLayer || [];
    this.track('js', new Date());
    this.track('config', analyticsId);
    this.createScriptElement();
    this.gtag = this.gtag.bind(this);
    this.track = this.track.bind(this);
    this.reportConversion = this.reportConversion.bind(this);
  }
  createScriptElement() {
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${analyticsId}`;
    document.body.appendChild(script);
  }
  gtag() {
    // Google Analytics won't work inside webview on iOS
    // if (this.runningOniOS && this.runningInUnity) return;
    // console.log(`ga: ${[...arguments].map(j => JSON.stringify(j)).join(', ')}`);
    window.dataLayer.push(arguments);
  }
  track() {
    this.gtag(...arguments);
  }
  eventName(canonicalEventName) {
    return canonicalEventName.split('.').join('_');
  }
  trackEvent({ eventName, category, label, customData }) {
    const data = { app_name: appName, event_category: category, event_label: label, ...customData };
    // in Google terms, the event name is the event action
    this.track('event', this.eventName(eventName), data);
  }
  reportConversion(conversionId, callback) {
    this.gtag('event', 'conversion', {
      send_to: `${adsId}/${conversionId}`,
      event_callback: callback
    });
  }
}

export default new GoogleAnalytics();
